import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import MakeHome from "../views/MakeHome";
import UploadPhoto from '../views/UploadPhoto.vue'
import Preview from "../views/Preview";
import Order from "../views/Order";
// import Introduce from '../views/Introduce.vue'
import Partners from '../views/Partners.vue'
import Examination from '../views/Examination.vue'
import Article from "../views/Article.vue"
import ArticleDetail from "../views/ArticleDetail.vue";
Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/makeHome',
    name: 'makeHome',
    component: MakeHome
  },
  {
    path: '/uploadPhoto',
    name: 'uploadPhoto',
    component: UploadPhoto
  },
  {
    path: '/preview',
    name: 'preview',
    component: Preview
  },
  {
    path: '/order',
    name: 'order',
    component: Order
  },

  {
    path: '/partners',
    name: 'partners',
    component: Partners
  },
  {
    path: '/article',
    name: 'article',
    component: Article
  },
  {
    path: '/articleDetail',
    name: 'articleDetail',
    component: ArticleDetail
  },
  {
    path: '/examination',
    name: 'examination',
    component: Examination
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
